import { useEffect, useState, useContext, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Nav from "../components/Nav";
import LeftSideBar from "../components/LeftSideBar";
import RightSideBar from "../components/RightSibeBar";
import BottomNavbar from "../components/BottomNavbar";
import { AppContext } from "../contexts/AppContext";
import { getCategoryList } from "../store/actions/utilActions";
import { useSelector, useDispatch } from "react-redux";

const Main = () => {
  const location = useLocation();
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const pathname = location.pathname;
  const appContext = useContext(AppContext);
  const [hide, setHide] = useState(false);
  const { categoryList } = useSelector((state) => state.utilData);

  useEffect(() => {
    if (
      pathname === "/myspace/payments" ||
      pathname === "/privacy-policy" ||
      pathname === "/refund-policy" ||
      pathname === "/tnc" ||
      pathname === "/customer-support"
    ) {
      setHide(true);
    } else {
      setHide(false);
    }
  }, [pathname]);

  useEffect(() => {
    dispatch(getCategoryList());
  }, []);

  const updateCategory = (id) => {
    appContext.updateCategory(id);
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -100, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
  };

  return (
    <div id="wrapper">
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Nav />
        </div>

        <div className="container top-container">
          {appContext.category !== "680c89f84f3447f6da04284f" ? (
            <div className="badge-wrapper">
              <button className="badge-arrow left" onClick={scrollLeft}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.64131 16.2749C6.41942 16.0531 6.39925 15.7058 6.5808 15.4612L6.64131 15.3911L12.0324 9.99967L6.64131 4.60828C6.41942 4.38639 6.39925 4.03917 6.58079 3.7945L6.64131 3.7244C6.8632 3.50251 7.21042 3.48234 7.45509 3.66388L7.52519 3.7244L13.3585 9.55773C13.5804 9.77962 13.6006 10.1268 13.419 10.3715L13.3585 10.4416L7.52519 16.2749C7.28112 16.519 6.88539 16.519 6.64131 16.2749Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </button>
              <div className="row">
                <div className="col-md-12">
                  <div className="skill-cat-badge cat-badge" ref={scrollRef}>
                    <span
                      className={`badge ${
                        appContext.category === "" && "badge-info"
                      }`}
                      onClick={() => updateCategory("")}
                    >
                      All
                    </span>
                    {categoryList
                      .filter(
                        (item) => item?._id !== "680c89f84f3447f6da04284f"
                      )
                      .map((item, index) => {
                        return (
                          <span
                            key={index}
                            className={`badge ${
                              appContext.category === item?._id && "badge-info"
                            }`}
                            onClick={() => updateCategory(item?._id)}
                          >
                            {item?.name}
                          </span>
                        );
                      })}
                  </div>
                </div>
              </div>
              <button className="badge-arrow right" onClick={scrollRight}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.64131 16.2749C6.41942 16.0531 6.39925 15.7058 6.5808 15.4612L6.64131 15.3911L12.0324 9.99967L6.64131 4.60828C6.41942 4.38639 6.39925 4.03917 6.58079 3.7945L6.64131 3.7244C6.8632 3.50251 7.21042 3.48234 7.45509 3.66388L7.52519 3.7244L13.3585 9.55773C13.5804 9.77962 13.6006 10.1268 13.419 10.3715L13.3585 10.4416L7.52519 16.2749C7.28112 16.519 6.88539 16.519 6.64131 16.2749Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </button>
            </div>
          ) : null}
          <div className="row">
            <div className="col-12 col-sm-5 col-md-4 col-lg-3 sidebar-wrapper mobile-sidebar">
              <div className="">
                <LeftSideBar />
              </div>
              <div className="rightSidevar-tabView">
                <RightSideBar calenderMobView={false} />
              </div>
            </div>
            <div
              className={`${
                !hide
                  ? "col-12 col-sm-7 col-md-8 col-lg-6"
                  : "col-12 col-sm-7 col-md-8 col-lg-6"
              } post`}
            >
              <Outlet />
            </div>
            {!hide && (
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 sidebar-wrapper rightSidebar-wrapper">
                <div className="">
                  <RightSideBar calenderMobView={true} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="bottom-wrapper">
          <BottomNavbar />
        </div>
      </div>
    </div>
  );
};

export default Main;
